module.exports = require('../../full/object/define-property');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/features/object/define-property.js
// module id = 477
// module chunks = 0 1